import React, { useState, useEffect } from 'react';
import { getUser, PHP_BACK } from '../../../../utils/Common';
import axios from "axios";
import vr from '../../../../utils/Verifiers';
import generalTools from '../../../sharecomponents/generalTools';
import VainillaDialog from '../../../sharecomponents/vanilladialog';
import Verifiers from '../../../../utils/Verifiers';
import { dateFormatConDiaYHoraShort } from '../../../../utils/DateFunctions';
const HistorialDeCargas = () => {
  const [loader, setloader] = useState();
  const [historyExcel, setHE] = useState([]);
  const [historial, sethistorial] = useState();
  const [FA, setFA] = useState({ section: 1, message: "" });
  const [plan, updatePlan] = useState([]);
  const [dialog, setdialog] = useState({ show: false });
  const [screen, setscreen] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    //historialExcel(true, undefined);
    getHistory();
    Verifiers.onScreenResize(setscreen);
  }, []);

  const getHistory = async () => {
    let resp = await vr.getDataAPI('excel/regs', {}, setloader, setdialog);
    if (!resp.estatus) {
      setHE([]);
      return;
    }
    setHE(resp.data);
    setFA({ section: 3, message: `Historial de cargas de actividades por documento Excel` });
  }

  const borrarRegistros = async (forzar = false, fecha) => {
    let resp = await vr.getDataAPI('excel/regs/delete', { forzarTodo: forzar, fecha }, setloader, setdialog);
    if (!resp.estatus) {
      return;
    }
    vr.activeDialog(setdialog, resp.msj, 'Eliminación exitosa', 'success');
    getHistory();
  }

  const confirmarBorrado = (forzoso, fecha) => {
    setdialog({
      tipo: forzoso ? "error" : "warning",
      show: true,
      title: "Confirme para continuar",
      body: forzoso ? "Esta acción borrará todos los registros de plan, ejecución, y todos los procesos posteriores asociados a estos registros de manera irreversible ¿Desea continuar?" :
        "Esta acción borrará todos los registros de plan que no esten asociados a ningín proceso posterior a la carga del plan de seimbra ¿Desea continuar?",
      funct: (resp) => {
        if (resp) {
          borrarRegistros(forzoso, fecha);
        } setdialog({ show: false })
      },
      respYes: "Si, elimnar",
      respNot: "Cancelar",
      size: 'm'
    })
  }

  return (
    <div className='w-100  text-center p-1 pt-0' style={{ maxHeight: Verifiers.maxHeight(screen), overflowY: 'auto' }}>
      {historyExcel && historyExcel.length > 0 && <div className='col-sm-12 p-1'>
        <div className='row justify-content-evenly w-100 m-0 p-0'>
          <div className='w-100 text-centter text-m text-300 mb-3'>Visualice las cargas manuales y de documentos Excel que se han realizado, <span className='text-danger'>Tenga mucho cuidado al borrar las entradas que haya cargado, pues al borrar un bloque, <span className='text-bold'>todos los registros de plan, ejecución, y siembra asociados a dichas entradas se borraran también</span>  </span></div>
          {
            historyExcel.map((hist, i) => {
              return (
                <React.Fragment key={vr.keyGen()}>
                  <div className='bw-1200 p-2 round-s border shadow-multi mb-3 mt-2'>
                    <div className='row justify-content-evenly m-0 p-0 w-100'>
                      <div className='bw-350 text-bold'>
                        Cargado: <span className='text-400 ms-1 text-m'>{dateFormatConDiaYHoraShort(hist.creado)}</span>
                      </div>
                      <div className='bw-350 text-bold'>
                        Cargas totales: <span className='text-400 ms-1 text-m'>{hist.totalRegs}</span>
                      </div>
                      <div className='bw-350 text-bold'>
                        Usuario: <span className='text-400 ms-1 text-m'>{hist.usuario}</span>
                      </div>
                      <div className='w-95 border-bottom border-warning' />
                      <div className='bw-200 mt-1 mb-1 round-s bg-light text-xs border text-center text-bold'>
                        Plan semilla:
                        <span className='text-center text-m text-500 ps-1'>{hist.totalReporteSemilla
                        }</span>
                      </div>
                      <div className='bw-200 mt-1 mb-1 round-s bg-light text-xs border text-center text-bold'>
                        Plan x día:
                        <span className='text-center text-m text-500 ps-1'>{hist.totalPlaneados}</span>
                      </div>
                      <div className='bw-200 mt-1 mb-1 round-s bg-light text-xs border text-center text-bold'>
                        Ejecucitado:
                        <span className='text-center text-m text-500 ps-1'>{hist.totalEjecutados}</span>
                      </div>
                      <div className='w-95 border-bottom' />
                      <div className='w-100 text-center text-bold text-s text-blue3'>Semanas incluidas</div>
                      <div className='row justify-content-center w-100 m-0 p-0'>
                        {hist.totalSemanasIncluidas.map((semana, i) =>
                          <div className='col-auto round-m bg-light contenedor border m-1' key={Verifiers.keyGen()}>{semana}</div>)}
                      </div>
                      <button className='btn btn-sm p-0 bw-200 m-1 round-xxl text-m border border-3 border-warning btn-danger shadow text-bold'
                        onClick={() => confirmarBorrado(1, hist.creado)}>
                        Borrado forzoso
                      </button>
                      <button className='btn btn-sm p-0 bw-250 m-1 round-xxl text-m border border-3 border-danger btn-light shadow text-bold'
                        onClick={() => confirmarBorrado(false, hist.creado)}>
                        Borrar registros<span className='ms-1 text-s'>(seguro)</span>
                      </button>

                    </div>
                  </div>
                  <div className='w-100' />
                </React.Fragment>
              )
            })
          }
        </div>
      </div>
      }
      <VainillaDialog data={dialog} />
    </div>
  )
}

export default HistorialDeCargas;